export default __webpack_public_path__ + "static/media/placeholder_600x400.e6c36480.svg";